var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C3.10457 4 4 3.10457 4 2C4 0.895431 3.10457 -3.91405e-08 2 -8.74228e-08C0.895431 -1.35705e-07 -3.91405e-08 0.89543 -8.74228e-08 2C-1.35705e-07 3.10457 0.89543 4 2 4ZM4 9C4 10.1046 3.10457 11 2 11C0.89543 11 -4.41685e-07 10.1046 -3.93402e-07 9C-3.4512e-07 7.89543 0.89543 7 2 7C3.10457 7 4 7.89543 4 9ZM4 16C4 17.1046 3.10457 18 2 18C0.89543 18 -7.47665e-07 17.1046 -6.99382e-07 16C-6.511e-07 14.8954 0.89543 14 2 14C3.10457 14 4 14.8954 4 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsBlack);
export default __webpack_public_path__ + "static/media/ActionsBlack.63749efbc1cddcd97105c88e87608d3c.svg";
export { ForwardRef as ReactComponent };